// extracted by mini-css-extract-plugin
module.exports = {"container":"yKV7TrASrEkgWlBosf_zW","groupsList":"_10yZiCqE6EakLxfXSYHwpN"};